import { render, staticRenderFns } from "./addShopReturnAddress.vue?vue&type=template&id=6a7b3f98"
import script from "./addShopReturnAddress.vue?vue&type=script&lang=js"
export * from "./addShopReturnAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports